<template>
  <BaseDialog v-model="showLogsDialog" :title="title" max-width="50vw">
    <template #information>
      <Logs :logs="logsArray" />
    </template>
  </BaseDialog>
</template>

<script>
import Logs from "./Logs.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
export default {
  components: { Logs, BaseDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Logs",
    },
    logsArray: {
      type: Array,
    },
  },
  computed: {
    showLogsDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>


